
const woosmapPublicKey = "woos-a10037a3-3f08-311e-af1d-2eb8b922749a";
const libraries = "widgets";
const env: string = "prod";
const eventYear:string = "2025";

const mapOptions: woosmap.map.MapOptions = {
  center: { lat: 49, lng: 9 },
  zoom: 18,
  styles: [
    { featureType: "all", stylers: [{ "saturation": -100 }] },
  ],
};
const mobileBreakPoint = 768;
const bucket = env === "prod" ? "" : "-stage";

const indoorRendererOptions: woosmap.map.IndoorRendererOptions = {
  centerMap: false,
  theme: `sdm_default_${eventYear}`,
  venue: env === "prod" ? `SDM_${eventYear}` : `sdm_${eventYear}_dev`,
  forceExtrusion: false,
  useInfoWindow: true,
  snapToVenueBounds: true,
  directionsIcons: {
    destinationIcon: {
      url: `https://indoor.woosmap.com/salone-del-mobile${bucket}/assets/location_on.png`,
      scaledSize: { height: 40, width: 40 },
      anchor: {x: 20, y: 38}
    },
    originIcon: {
      url: `https://indoor.woosmap.com/salone-del-mobile${bucket}/assets/trip_origin.png?v=1`,
      scaledSize: { height: 30, width: 30 },
      anchor: {x: 15, y: 15}
    }
  },
  polylineOptions: {
    color: "#00158F",
    strokeColor: "#00158F",
    highlightColor: "#00D9FF"
  }
};
const widgetOptions: woosmap.map.IndoorWidgetOptions = {
  // autocompleteWithDistance: true,
  ui: {
    primaryColor: "rgb(0 0 0 / 80%)",
    secondaryColor: "#e30613",
  },
  autocomplete: {
    maxResponses: 10,
    autocompleteWithDistance: false,
    baseFilter: ""
  }
};
const GATag: string = env === "prod" ? "GTM-WJM8VDL2" : "GTM-MQ2P2JCK";
const themes: { [key: string]: string } = {
  default: `sdm_default_${eventYear}`,
  favorites: "favorites",
}
export default {
  mapOptions: mapOptions,
  indoorRendererOptions: indoorRendererOptions,
  indoorWidgetOptions: widgetOptions,
  woosmapPublicKey: woosmapPublicKey,
  libraries: libraries,
  query: '',
  GATag: GATag,
  env: env,
  themes: themes,
  mobileBreakPoint: mobileBreakPoint,
  eventYear: eventYear
}
